import { useUserPermission } from '../../hooks/useUserPermission';
import { HasPermissionProps } from './types';

export function HasUserPermission({ permissions, children, partial = false }: Omit<HasPermissionProps, 'id'>) {
  const { isLoading, hasAnyPermission, hasPermission } = useUserPermission();
  if (isLoading) return null;
  if (partial ? !hasAnyPermission(permissions) : !hasPermission(permissions)) return null;
  return <>{children}</>;
}
